import React, { useEffect } from 'react';
import Subheader from '../../component/Subheader';
import GalleryFilter from './GalleryFilter';
import { useNavigate, useParams } from 'react-router-dom';

export default function Gallery({initialData}) {
  const navigate = useNavigate();
  const { gallery_slug } = useParams();
  const pageName = gallery_slug.includes("goa") ? "Goa" : gallery_slug.includes("rishikesh") ? "Rishikesh" : "Corbett"

  const pageSlug = gallery_slug.includes("goa ") ? "/resort-de-coracao-goa" : gallery_slug.includes("rishikesh") ? "/resort-de-coracao-rishikesh" : "/resort-de-coracao-corbett"

  const subheadData = {
    heading: 'Photo Gallery - Resort De Coracao',
    breadcrumb: [
      {
        slug: pageSlug,
        name: pageName,
      },
      {
        name: "Photo Gallery",
      },
    ]
  }

  useEffect(() => {
    if (pageName === "Rishikesh") {
      navigate("/404");
    }
  }, [pageName, navigate]);

  return (
    <>
      <Subheader subheadData={subheadData} />
      <GalleryFilter initialData={initialData}/>
    </>
  )
}
